<template lang="pug">
    .game-container
          .game__prepared_items
                .game__answer_item(:style='{color: colorForAnswer}' :class='{blackStroke: colorForAnswer=="#FEFF35"}') {{ answerToShow }}
          img.game__distraction_item(
              v-if="pictures"
              ref="distractionImage"
              :src="getDistractionImg()")

</template>

<script>
    import { mapState } from 'vuex';
    const MAX_IMAGE_HEIGHT = 200;
    const MAX_IMAGE_WIDTH = 150;

    export default {
        props: {
            preparedItems: Object,
            time: Number,
            showTime: Number,
            wordsMovement: Boolean,
            pictures: Boolean,
            courseType: String,
        },
        data() {
            return {
                answerToShow: null,
                image: null,
                possibleColors: ['#FEFF35', '#3233CC', '#FF9900', '#66CC00', '#00CCFF', '#FE0000', '#000000'],
                colorForAnswer: null,
            };
        },
        watch: {
            time(val) {
                if (val % this.showTime === 0 || val === 1) {
                    this.getCurrentAnswer();
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                let image = this.$refs.distractionImage;
                if (image) {
                    image.onload = () => {
                        this.getDistractionImageSize();
                    };
                }
            });
        },
        methods: {
            getRandomIndex(array) {
                const numOfItems = array.length;
                return Math.floor(Math.random() * numOfItems);
            },
            getDistractionImageSize() {
                let coefficient = window.innerWidth >= 1200 ? 0.8 : 0.4;
                this.$refs.distractionImage.style.width = this.$refs.distractionImage.naturalWidth * coefficient + 'px';
                this.$refs.distractionImage.style.height = this.$refs.distractionImage.naturalHeight * coefficient + 'px';
            },
            generateItemPosition(className) {
                let containerWidth = document.querySelector('.game-container').clientWidth;
                let containerHeight = document.querySelector('.game-container').clientHeight;
                let item = document.querySelector(className).style;
                if (window.innerWidth > 1200) {
                    item.top = _.random(0, containerHeight - MAX_IMAGE_HEIGHT) + 'px';
                    if(this.answerToShow.length > 8) {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 250) + 'px';
                    } else if(this.answerToShow.length > 6) {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 200) + 'px';
                    } else {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 150) + 'px';
                    }
                }
                if (window.innerWidth >= 992 && containerWidth <= 1200) {
                    item.top = _.random(0, containerHeight - MAX_IMAGE_HEIGHT - 50) + 'px';
                    if(this.answerToShow.length > 8) {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 280) + 'px';
                    } else if(this.answerToShow.length > 6) {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 230) + 'px';
                    } else {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 180) + 'px';
                    }
                }
                if (window.innerWidth < 992) {
                    item.top = _.random(0, containerHeight - MAX_IMAGE_HEIGHT + 50) + 'px';
                    if(this.answerToShow.length > 8) {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 200) + 'px';
                    } else if(this.answerToShow.length > 6) {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 150) + 'px';
                    } else {
                        item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 100) + 'px';
                    }
                }
            },
            getDistractionImg() {
                const randomNumber = _.random(0, 28);
                return '/imgs/distracting-pictures/' + randomNumber + '.png';
            },
            getDistractingImagePosition() {
                if (this.$refs.distractionImage) {
                    this.$refs.distractionImage.style.left = 0;
                    this.$refs.distractionImage.style.top = 0;
                    let containerWidth = document.querySelector('.game-container').clientWidth;
                    let containerHeight = document.querySelector('.game-container').clientHeight;
                    this.$refs.distractionImage.style.left = _.random(0, containerWidth - this.$refs.distractionImage.naturalWidth) + 'px';
                    this.$refs.distractionImage.style.top = _.random(0, containerHeight - this.$refs.distractionImage.naturalWidth) + 'px';
                }
            },
            getCurrentAnswer() {
                let prevRes = this.answerToShow;
                let futureRes = this.translatedAnswers[this.getRandomIndex(this.translatedAnswers)];
                if (futureRes === prevRes) {
                    return this.getCurrentAnswer();
                }
                this.getColor();
                this.answerToShow = futureRes;
                this.pictures && this.getDistractingImagePosition();
                this.wordsMovement && this.generateItemPosition('.game__prepared_items');
            },
            getColor() {
                let prevRes = this.colorForAnswer;
                let futureRes = this.possibleColors[this.getRandomIndex(this.possibleColors)];
                if (prevRes === futureRes) {
                    return this.getColor();
                }
                this.colorForAnswer = futureRes;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            translatedAnswers() {
                if (this.user.locale in this.preparedItems && this.courseType !== 'readingEn') {
                    return this.preparedItems[this.user.locale];
                } else {
                    return this.preparedItems['en'];
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .game-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90%;
        height: 100%;
        font-size: 45px;
        font-weight: 600;
        @include media($lg) {
            font-size: 70px;
        }
        @include media($xl) {
            font-size: 90px;
        }
    }
    .game__prepared_items {
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
    }
    .game__answer_item {
        -webkit-text-stroke: 2px rgba(255, 255, 255, 0.8);
    }
    .blackStroke {
        -webkit-text-stroke: 2px rgba(0, 0, 0, 0.5);
    }
    .game__distraction_item {
        position: absolute;
        opacity: 0.6;
    }
</style>
